export function useInStoryblokEditor() {
	return Boolean(
		process.env.NEXT_PUBLIC_PREVIEW_ENABLED && new URLSearchParams(global.location?.search).has('_storyblok'),
	);
}
